import { createSelector } from "reselect";
import { take } from "lodash";

const searchResults = (state) => state.searchResults;
const newsSearchresults = (state) => state.newsSearchresults;
const pageSize = (state) => state.pageSize;

export const getPaginatedSearchResults = createSelector(
    [searchResults, pageSize],
    (searchResults, pageSize) => {
        return take(searchResults, pageSize);
    }
);

export const getPaginatedNewsSearchResults = createSelector(
    [newsSearchresults, pageSize],
    (newsSearchresults, pageSize) => {
        return take(newsSearchresults, pageSize);
    }
);
